<template>
  <b-modal id="eidentity-authentication-modal" hide-footer hide-header ref="signicatAuthentication" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop" @hidden="resetValues">
    <div class="auth-box">
      <div v-if="errorMsg" class="text-center">
        {{ errorMsg }}
        <div class="mb-16 mt-16">
          <button type="button" class="btn btn-secondary" @click="close">
            Close
          </button>
        </div>
      </div>
      <div v-else-if="isAuthInProgress">
        <div class="mt-20 mb-20 text-center timer">
          Time left <span>{{ timer.minutes }}:{{ timer.seconds }}</span>
        </div>
        <div data-title=".dot-stretching">
          <div class="stage">
            <div class="dot-stretching"></div>
          </div>
        </div>
        <h5 class="text-center mt-20">
          Authentication and Signing in Progress. Please wait. Your details are being processed...
        </h5>
      </div>
      <div v-else class="text-center">
        <h5>
          To initiate the authentication process please click on the "Next" button, you will then be redirected to the new tab to continue the authentication process.
        </h5>
        <div class="mt-25 pl-20 pr-20">
          <button type="button" class="btn btn-secondary float-left" @click="close" :disabled="isApiCallInProgress">
            Cancel
          </button>
          <button type="button" class="btn btn-primary float-right" @click="requestPISignature" :disabled="isApiCallInProgress">
            Next
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import localStorageService from "@/services/localStorage";
import _ from "lodash";

export default {
  name: "eIdent-authentication-modal",
  data() {
    return {
      authenticationURL: null,
      noCloseOnBackdrop: true,
      isAuthInProgress: false,
      errorMsg: null,
      timer: {
        minutes: 14,
        seconds: 59
      },
      authData: null,
      isApiCallInProgress: false,
      taskId: null,
      orderStatusRefreshInterval: null
    };
  },
  props: {
    esignAuthData: Object
  },
  methods: {
    show() {
      this.$refs.signicatAuthentication.show();
    },
    close() {
      if (this.errorMsg) {
        //redirect to document details page.
        this.$router.go();
      }
      this.$refs.signicatAuthentication.hide();
    },
    resetValues() {
      this.authenticationURL = null;
      this.isAuthInProgress = false;
      this.errorMsg = null;
      this.timer = {
        minutes: 4,
        seconds: 59
      };
      this.authData = null;
    },
    openAuthenticationURL() {
      this.isAuthInProgress = true;
      this.startTimer(); //Start the timer
      window.open(this.authenticationURL, "_blank");

      //Reload appointments every 15 seconds
      this.orderStatusRefreshInterval = window.setInterval(() => {
        this.getEsignOrderStatus();
      }, 15000);
    },
    startTimer() {
      this.timer.seconds = this.checkSecond(this.timer.seconds - 1);
      if (this.timer.seconds == 59) {
        this.timer.minutes = this.timer.minutes - 1;
      }
      if (this.timer.minutes <= 0) {
        return;
      }
      setTimeout(this.startTimer, 1000);
    },
    checkSecond(secOld) {
      let sec = secOld;
      if (sec < 10 && sec >= 0) {
        sec = "0" + sec;
      } // add zero in front of numbers < 10
      if (sec < 0) {
        sec = 59;
      }
      return sec;
    },
    requestPISignature() {
      this.isApiCallInProgress = true;
      const userObj = localStorageService.getItem("userObj");
      const requestObj = [
        {
          initialImageData: null,
          signatureImageData: null,
          firstName: null,
          lastName: null,
          responseList: null
        }
      ];
      const dataObj = {
        studyId: this.authData.studyId,
        participantId: this.authData.participantId,
        docId: this.authData.docId,
        requestObj,
        siteId: userObj && userObj.siteIds && userObj.siteIds[0]
      };
      this.$api.requestConfiguredPISignatureFact(dataObj).then(
        response => {
          this.isApiCallInProgress = false;
          if (response.body.message) {
            //Open url in new tab method
            this.authenticationURL = response.body.message;
            const params = new URLSearchParams(this.authenticationURL.split("?")[1]);
            // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
            this.taskId = params.get("task_id"); // "some_value"

            this.openAuthenticationURL();
          } else {
            this.$toastr.error("API did not return the signing URL!");
          }
        },
        error => {
          this.isApiCallInProgress = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while sending signing request.");
        }
      );
    },
    getEsignOrderStatus() {
      const queryString = {
        docId: this.authData.docId,
        orderTaskId: this.taskId,
        type: "task",
        userType: "user",
        studyId: this.authData.studyId
      };
      this.$api.esignOrderStatus(queryString).then(
        response => {
          //Based on the status redirect to document details page.
          const taskStatus = response.body.data.orderStatus.toLowerCase();
          if (taskStatus == "completed") {
            this.isAuthInProgress = false;
            clearInterval(this.orderStatusRefreshInterval);
            this.resetValues();
            //redirect to document details page.
            this.$router.go();
          } else if (taskStatus == "rejected") {
            this.isAuthInProgress = false;
            clearInterval(this.orderStatusRefreshInterval);
            this.errorMsg = "The authentication and signature process was not completed.";
          }
        },
        error => {
          this.isAuthInProgress = false;
          clearInterval(this.orderStatusRefreshInterval);
          this.errorMsg = error.body && error.body.message ? error.body.message : "Error while getting the site team sign status!";
        }
      );
    }
  },
  watch: {
    timer: {
      deep: true,
      handler(data) {
        if (data.minutes == 0) {
          this.errorMsg = "You have reached the maximum time limit of completing the authentication process. Please start over.";
          this.isAuthInProgress = false;
          clearInterval(this.orderStatusRefreshInterval);
        }
      }
    },
    esignAuthData(data) {
      if (data) {
        this.authData = _.cloneDeep(data);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.orderStatusRefreshInterval);
  }
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  #eidentity-authentication-modal {
    .modal-dialog {
      min-width: 600px;
    }
  }
}
</style>
<style scoped lang="scss">
#eidentity-authentication-modal {
  .modal-dialog {
    vertical-align: top;
  }

  .modal {
    color: #4a4a4a;
  }

  .modal-header {
    border: 0;
    padding-bottom: 0;
  }

  .btn-primary {
    background-color: #1e8fe1;
    border-color: #1e8fe1;

    &.disabled {
      cursor: not-allowed;

      &:hover {
        cursor: not-allowed;
      }
    }
  }

  .btn-primary:hover {
    background-color: #0069d9;
    border-color: #0069d9;
  }

  .btn-primary:hover {
    background-color: #1e8fe1;
    color: #fff;
  }

  .btn-primary,
  .btn-secondary {
    /* padding: 0.25rem 1.6rem; */
    padding: 0.25rem 3rem;
  }

  .btn-outline-secondary {
    border-color: #b0bac9;
    padding: 0.25rem 1.6rem;
    color: #4a4a4a;
  }

  .btn-outline-secondary:hover {
    color: #ffffff;
  }

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #4a4a4a;
  }

  .auth-box {
    padding-left: 50px;
    padding-right: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 275px;
    background: #f5f8fa;
    max-height: 275px;

    .stage {
      display: flex;
      justify-content: center;
    }

    .timer {
      font-size: 24px;
      color: #00365a;
    }
  }
}
</style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
